import { Title, Subtitle } from 'components/DesktopTable/Empty/styles';
import React from 'react';

const MailMergesNotFound = () => {
  return (
    <>
      <Title>No results found</Title>
      <Subtitle>
        Sorry, there is no mail merge that fits with your search.
      </Subtitle>
    </>
  );
};

export default MailMergesNotFound;
